import moment from 'moment'

export type ResolveSlotReferenceDateTimeParams = {
  currentDateTime: string
  originalDateTime?: string
  variationCode?: string
  variationCodeOffset?: string
  variationCodeAdjustedTime?: string
}

const isSameDateTime = (dateTime: string, dateTimeToCompare?: string): boolean => {
  if (!dateTimeToCompare) {
    return false
  }

  const date = moment(dateTime)
  const dateToCompare = moment(dateTimeToCompare)

  return date.isValid() && dateToCompare.isValid() && date.isSame(dateToCompare, 'minute')
}

const isNonTimeOffsetVariationCode = (variationCode?: string): boolean => {
  return variationCode?.toUpperCase().startsWith('MD') ?? false
}

const hasUsableVariationCodeOffset = (variationCodeOffset?: string): boolean => {
  if (!variationCodeOffset) {
    return false
  }

  const offset = moment.duration(variationCodeOffset)

  return offset.isValid() && offset.asMilliseconds() !== 0
}

export const resolveVariationCodeSlotReferenceDateTime = ({
  currentDateTime,
  originalDateTime,
  variationCode,
  variationCodeOffset,
  variationCodeAdjustedTime
}: ResolveSlotReferenceDateTimeParams): string => {
  if (
    !variationCode ||
    !variationCodeAdjustedTime ||
    isNonTimeOffsetVariationCode(variationCode) ||
    !hasUsableVariationCodeOffset(variationCodeOffset)
  ) {
    return currentDateTime
  }

  if (
    isSameDateTime(currentDateTime, originalDateTime) ||
    isSameDateTime(currentDateTime, variationCodeAdjustedTime)
  ) {
    return variationCodeAdjustedTime
  }

  return currentDateTime
}
